module.exports = __webpack_public_path__ + "img/file_pdf.svg.9d2ce81a.webp";